import i18next, { type ResourceKey } from "i18next";
import { initReactI18next } from "react-i18next";
import { z } from "zod";

export const TranslationSchema: z.ZodType<ResourceKey> = z.lazy(() =>
  z.record(
    z.string(),
    z.union([TranslationSchema, z.string(), z.string().array(), z.undefined()]),
  ),
);

const consoleLogger = {
  type: "logger",

  log(args: string[]) {
    this.output("log", args);
  },

  warn(args: string[]) {
    this.output("warn", args);
  },

  error(args: string[]) {
    this.output("error", args);
  },

  output(type: "log" | "info" | "warn" | "error", args: string[]) {
    if (Array.isArray(args)) {
      if (args[0] === "i18next: languageChanged") {
        return;
      }

      if (args[0] === "i18next: initialized") {
        return;
      }
    }

    console?.[type](...args);
  },
} as const;

i18next
  .use(initReactI18next)
  .use(consoleLogger)
  .init({
    lng: document.documentElement.lang,
    resources: {},
    interpolation: {
      escapeValue: false, // react already safes from xss
    },
    nsSeparator: false,
    debug: import.meta.env.DEV,
  });

export const addTranslation = (resources: ResourceKey) => {
  i18next.addResourceBundle(
    document.documentElement.lang,
    "translation",
    resources,
    true,
    true,
  );
};
